import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { ImgCardComponent } from '@app/components/img-card';
import { PaginatorComponent } from '@app/components/paginator';

type CardType = 'groupChallenge' | 'stepChallenge' | 'upcomingChallenge';

export interface CardData<T> {
  type?: CardType;
  backgroundColor?: string;
  title?: string;
  subtitle?: string;
  imageUrl?: string;
  data?: T;
  tag?: string;
  tagColor?: string;
}

@Component({
  selector: 'app-card-data-grid',
  templateUrl: './card-data-grid.component.html',
  styleUrl: './card-data-grid.component.css',
  standalone: true,
  imports: [CommonModule, PaginatorComponent, ImgCardComponent],
})
export class CardDataGridComponent implements OnInit {
  private readonly sanitizer = inject(DomSanitizer);
  @Input() autoPaginate = true;
  @Input() data = new Array<CardData<never>>();
  @Input() pageSize = 16;
  @Input() aspectRatio = '16/9';
  @Input() overlayColor = '#0000001a';
  @Output() cardSelected = new EventEmitter<CardData<never>>();
  cards = new Array<CardData<never>>();
  pageIndex = 0;
  length = 0;

  ngOnInit(): void {
    this.updateCards();
  }

  onPageChanged(page: number): void {
    this.pageIndex = page - 1;
    this.updateCards();
  }

  backgroundUrl(url: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(`url(${url})`);
  }

  onCardSelected(card: CardData<never>): void {
    this.cardSelected.emit(card);
  }

  private updateCards(): void {
    this.length = this.data.length;
    this.cards = this.autoPaginate
      ? [...this.data].splice(this.pageIndex * this.pageSize, this.pageSize)
      : this.data;
  }
}
